import Permissions from '@wielink-application/shared/js/mixins/permissions.js'
export default Permissions;
